import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';
import type { PropertyRelationship } from '../../components/PropertyRelationship/PropertyRelationship';

export interface TrackSaveProperty {
  event_name: 'pca_save_property';
  user_action: 'save' | 'update' | 'unsave';
  in_page_source: string;
  property_relationship: PropertyRelationship | null;
}

export const trackSaveProperty = (
  eventData: Readonly<Omit<TrackSaveProperty, 'event_name'>>,
): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_save_property/jsonschema/1-0-2',
    data: {
      ...eventData,
      event_name: 'pca_save_property',
    },
  });

  trackEvent(event);
};
